import {Component, EventEmitter, Inject, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, Validators} from "@angular/forms";
import {EstudioService} from "../estudio.service";
import {MAT_DIALOG_DATA } from "@angular/material/dialog";
import {CustomAlertService} from "../../../_components/custom-alert/custom-alert.service";
import {Evento} from "../../../_models/evento";
import {environment} from "../../../../environments/environment";
import {ComentariosService} from "../../../_components/glm-comentarios/comentarios.service";
import {AuthenticationService} from "../../../_services";
import { CkeditorImageDeleteDirective } from 'src/app/_directives/ckeditor-image-delete/ckeditor-image-delete.directive';

const API_URL = environment.apiUrl;

@Component({
  selector: 'meta-rapida-form',
  standalone: false,
  templateUrl: 'evento-rapido-form.component.html',
  styleUrls: ['../unidad-etapas/unidad-etapas-generales.scss','../meta-form/meta-form-component.scss']
})

export class EventoRapidoFormComponent implements OnInit {

  evento: Evento;

  resumenForm = new UntypedFormControl();
  tipoEvento;
  nombreEvento;
  tiposEvento: any[] = [];

  ckeditorImageEndPoint = `${API_URL}/api/storage/uploadimg`;
  refreshUrl = `${API_URL}/api/jwt/refresh`;
  userToken;
  refreshToken;

  onSave = new EventEmitter();
  saving: boolean = false;

  @ViewChild(CkeditorImageDeleteDirective) imageDelete: CkeditorImageDeleteDirective;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private estudioService: EstudioService,
              private customAlertService: CustomAlertService,
              private authService: AuthenticationService) {
    this.userToken = authService.currentUserValue.token;
    this.refreshToken = authService.currentUserValue.refresh;
  }

  ngOnInit() {
    let cursos = [],
      materias = [];
    this.data.mcps.map(mcp => {
      if (cursos.filter(cur => cur.id == mcp.cursoParentID).length == 0) {
        cursos.push({id: mcp.cursoParentID});
      }
      if (materias.filter(mat => mat.id == mcp.materiaID).length == 0) {
        materias.push({id: mcp.materiaID});
      }
    });

    this.tiposEvento = this.data.categorias;

    this.evento = new Evento({id: 0, cursos: cursos, materias: materias, editores: this.data.editores});

    this.tipoEvento = new UntypedFormControl('', Validators.required);
    this.nombreEvento = new UntypedFormControl('', Validators.required);
  }

  guardar(continuar: boolean = false) {
    this.saving = true;
    this.evento.categoriaID = this.tipoEvento.value;
    this.evento.categoria = {id: this.tipoEvento.value};
    this.evento.nombre = this.nombreEvento.value;
    this.evento.resumen = this.resumenForm.value;

    this.estudioService.crearEvento(this.evento).subscribe(resp => {
      this.imageDelete.reset();
      let nuevoEvento = new Evento(this.estudioService.extractData(resp));
      this.estudioService.actualizarLista(nuevoEvento, 'evento', continuar);
      this.onSave.emit({continuar, eventoID: nuevoEvento.id});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
      })
    });
  }
}
